import React from "react";
import { Typography } from "components/SemanticComponents";

export default function Heading({ item }) {
  const { text } = JSON.parse(item.data);
  return <Typography.Title level="h2">{text}</Typography.Title>;
}
